import styled from "@emotion/styled";
import Card from '../components/card';

export const CardProducts = styled(Card)`
  display: flex;
  flex-wrap: wrap;
`;
